<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Customer Credit</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            add_credit: 'add_credit',
            add_cashback: 'add_cashback',
          }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :addCreatCreditButton="true"
          :openCreatCreditModal="openCreatCreditModal"
          :cashBackButton="true"
          :openCashBackModal="openCashBackModal"
          :addExportButton="true"
          :sendToExport="sendToExport"
          :tableData="tableData"
          :resetGetResults2="resetGetResults2"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.credit_invoice_id"
              >
                <!-- <td>{{ r.branch_name }}</td> -->
                <td>{{ r.staff_name }}</td>
                <td>{{ r.customer_id }}</td>
                <td class="ws-nowrap">
                  {{ r.customer_name }}
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td>{{ r.phone_number }}</td>
                <td v-if="r.credit_status === 'add'">
                  <span class="label bg-green-600"> {{ r.credit_status }}</span>
                </td>
                <td v-if="r.credit_status === 'cash back'">
                  <span class="label bg-orange-600"> {{ r.credit_status }}</span>
                </td>
                <td>${{ r.amount }}</td>
                <td>{{ r.invoice_number }}</td>
                <td>{{ r.note }}</td>
                <td v-if="r.credit_invoice_date != null">{{ r.credit_invoice_date }}</td>
                <td v-else>{{ r.created_at }}</td>
                <td style="padding-left:10px; padding-right:5px">
                  <a
                    style="color:#424242"
                    tooltip="View Invoice"
                    @click="initDetail('modal_showApp', r.credit_invoice_id)"
                  >
                    <i class="material-icons">assignment</i>
                  </a>
                </td>
                <td
                  v-if="r.credit_status === 'add' && $_has_perm('edit_credit')"
                  style="padding-left:0px; padding-right:0px"
                >
                  <a
                    style="color:#01579B"
                    tooltip="Edit"
                    @click="openEditCreditModal(r)"
                  >
                    <i class="material-icons">edit</i>
                  </a>
                </td>
                <td
                  v-else-if="$_has_perm('edit_cashback')"
                  style="padding-left:0px; padding-right:0px"
                >
                  <a
                    style="color:#01579B"
                    tooltip="Edit"
                    @click="openEditCashBackModal(r)"
                  >
                    <i class="material-icons">edit</i>
                  </a>
                </td>
                <td
                  v-if="r.credit_status === 'add' && $_has_perm('delete_credit')"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a
                    style="color:#C62828"
                    tooltip="Delete"
                    @click="deleteCredit(r.credit_invoice_id)"
                  >
                    <i class="material-icons">delete</i>
                  </a>
                </td>
                <td
                  v-else-if="$_has_perm('delete_cashback')"
                  style="padding-left:0px; padding-right:5px"
                >
                  <a
                    style="color:#C62828"
                    tooltip="Delete"
                    @click="deleteCashBack(r.credit_invoice_id)"
                  >
                    <i class="material-icons">delete</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    phone_number="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <table class="table">
            <tr>
              <td style="padding: 3px; font-weight: bold">
                Total income (Add +): &nbsp; ${{ totalAdd }}
              </td>
            </tr>
            <tr>
              <td style="padding: 3px; font-weight: bold">
                Total outgoing (CashBack -): &nbsp; ${{ totalCashBack }}
              </td>
            </tr>
            <tr>
              <td style="padding: 3px; font-weight: bold">
                General Total: &nbsp; ${{ generalTotal }}
              </td>
            </tr>
          </table>

          <mobile-datatable
            v-if="isMobile"
            :isCustomerCredit="true"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  Invoice No: {{ r.invoice_number }} , <br />
                  Staff: {{ r.staff_name }} , <br />
                  CustomerID: {{ r.customer_id }} , <br />
                  Customer: {{ r.customer_name }} , <br />
                  CustomerPhone: {{ r.phone_number }}, <br />
                </td>
                <td>
                  <span v-if="r.credit_status === 'add'">
                    <span class="label bg-green-600"> {{ r.credit_status }}</span>
                  </span>
                  <span v-if="r.credit_status === 'cash back'">
                    <span class="label bg-orange-600"> {{ r.credit_status }}</span>
                  </span>
                  <br />
                  <span>${{ r.amount }}</span> , <br />
                  <span v-if="r.note != null">Note: {{ r.note }}, <br /></span>
                  <span v-if="r.credit_invoice_date != null">{{ r.credit_invoice_date }}</span>
                  <span v-else>{{ r.created_at }}</span>
                  <br />
                  <span style="padding-left:0px; padding-right:5px; display: inline-block">
                    <a
                      style="color:#424242"
                      tooltip="View Invoice"
                      @click="initDetail('modal_showApp', r.credit_invoice_id)"
                    >
                      <i class="material-icons">assignment</i>
                    </a>
                  </span>
                  <span
                    v-if="r.credit_status === 'add' && $_has_perm('edit_credit')"
                    style="padding-left:0px; padding-right:0px; float: left"
                  >
                    <a
                      style="color:#01579B"
                      tooltip="Edit"
                      @click="openEditCreditModal(r)"
                    >
                      <i class="material-icons">edit</i>
                    </a>
                  </span>
                  <span
                    v-else-if="$_has_perm('edit_cashback')"
                    style="padding-left:0px; padding-right:0px; float: left"
                  >
                    <a
                      style="color:#01579B"
                      tooltip="Edit"
                      @click="openEditCashBackModal(r)"
                    >
                      <i class="material-icons">edit</i>
                    </a>
                  </span>
                  <span
                    v-if="r.credit_status === 'add' && $_has_perm('delete_credit')"
                    style="padding-left:0px; padding-right:0px; float: left"
                  >
                    <a
                      style="color:#C62828"
                      tooltip="Delete"
                      @click="deleteCredit(r.credit_invoice_id)"
                    >
                      <i class="material-icons">delete</i>
                    </a>
                  </span>
                  <span
                    v-else-if="$_has_perm('delete_cashback')"
                    style="padding-left:0px; padding-right:0px; float: left"
                  >
                    <a
                      style="color:#C62828"
                      tooltip="Delete"
                      @click="deleteCashBack(r.credit_invoice_id)"
                    >
                      <i class="material-icons">delete</i>
                    </a>
                  </span>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <creat-credit
            :createCreditModal="createCreditModal"
            :createCredit="createCredit"
            :addData="addData"
            :checkAlert="checkAlert"
            :closeCreatCreditModal="closeCreatCreditModal"
            :customers="customers"
            :load="load"
          ></creat-credit>

          <cash-back
            :cashBackModal="cashBackModal"
            :cashBack="cashBack"
            :cashBackData="cashBackData"
            :checkAlert="checkAlert"
            :cashBackError="cashBackError"
            :closeCashBackModal="closeCashBackModal"
            :customers="customers"
            :load2="load2"
          ></cash-back>

          <edit-credit
            :editCreditModal="editCreditModal"
            :editCredit="editCredit"
            :editData="editData"
            :checkAlert="checkAlert"
            :closeEditCreditModal="closeEditCreditModal"
            :customers="customers"
            :backendError="backendError"
            :load2="load2"
          ></edit-credit>

          <edit-cash-back
            :editCashBackModal="editCashBackModal"
            :closeEditCashBackModal="closeEditCashBackModal"
            :checkAlert="checkAlert"
            :editCashBackData="editCashBackData"
            :editCashBack="editCashBack"
            :backendError="backendError"
          ></edit-cash-back>

          <view-action-log
            :detailData="detailData"
            :closeModal="closeModal"
            :companyData="companyData"
          ></view-action-log>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              ></paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../../Pagination'
import preDatatableComponent from '../../preDatatableComponent'
import DatatableVue from '../../Datatable'
import createCredit from './createCredit.vue'
import editCredit from './editCredit.vue'
import editCashBack from './editCashBack.vue'
import cashBack from './cashBack.vue'
import viewActionLog from '../../logs/viewActionLog.vue'
import mobileDatatable from '../../mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'creat-credit': createCredit,
    'edit-credit': editCredit,
    'edit-cash-back': editCashBack,
    'cash-back': cashBack,
    'view-action-log': viewActionLog,
    'mobile-datatable': mobileDatatable
  },
  created() {
    this.getResults()
  },
  mounted() {
    this.perPageFix()
    this.getCustomer()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      // {
      //   label: 'Branch',
      //   text: 'Branch',
      //   value: '1',
      //   sortable: true,
      //   searchable: false,
      //   name: 'branch_name'
      // },
      {
        label: 'Staff Name',
        text: 'Staff Name',
        value: '1',
        sortable: true,
        searchable: true,
        name: 'staff_name'
      },
      {
        label: 'Customer ID',
        text: 'Customer ID',
        value: '2',
        sortable: true,
        searchable: true,
        name: 'customer_id'
      },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'customer_name'
      },
      {
        label: 'Customer Phone',
        text: 'Customer Phone',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'phone_number'
      },
      {
        label: 'Action',
        text: 'Action',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'credit_status'
      },
      {
        label: 'Amount',
        text: 'Amount',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'amount'
      },
      {
        label: 'Invoice Number',
        text: 'Invoice Number',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'invoice_number'
      },
      {
        label: 'Note',
        text: 'Note',
        value: '8',
        sortable: true,
        searchable: true,
        name: 'note'
      },
      {
        label: 'Credit Date',
        text: 'Credit Date',
        value: '9',
        sortable: true,
        searchable: true,
        name: 'credit_invoice_date'
      }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      url: 'api/credit_invoices',
      baseUrl: 'api/credit_invoices',
      getCustomerUrl: 'api/get-customer-to-select',
      cashBackUrl: 'api/cash_back',
      invoiceUrl: 'api/customer_last_invoice',
      companyUrl: 'api/company_info',
      deleteCashBackUrl: 'api/delete_cash_back',
      editCashBackUrl: 'api/edit_cash_back',
      createCreditModal: false,
      editCreditModal: false,
      alertValue: false,
      checkAlert: false,
      filterMade: false,
      totalResult: 0,
      backendError: false,
      btnsave: true,
      load: false,
      load2: false,
      cashBackModal: false,
      cashBackError: false,
      editCashBackModal: false,
      editCashBackData: {
        amount: ''
      },
      totalAdd: 0,
      totalCashBack: 0,
      generalTotal: 0,
      prevSearchQuery: '',
      apiResults: [],
      customersResult: [],
      customers: [],
      customerCreditId: [],
      columns: columns,
      sortKey: 'credit_invoice_id',
      sortOrders: sortOrders,
      the_credit_invoice_id: '',
      companyData: {},
      addData: {},
      cashBackData: {},
      editData: {},
      detailData: {
        credit_log_action_id: '',
        invoice_number: '',
        description: '',
        action: '',
        created_at: '',
        amount: '',
        customer_name: '',
        customer_email: '',
        customer_address: '',
        phone_number: '',
        note: '',
        credit_log_action_date: '',
        old_price: ''
      },
      tableData: {
        per_page: 10,
        search: '',
        column: 'credit_invoice_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'credit_invoice_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'credit_invoice_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    getResults(url = this.url) {
      let token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          this.getCustomerCreditID(this.apiResults)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          let totalAdd = 0
          let totalCashBack = 0
          let generalTotal = 0

          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
            if (this.apiResults[i].credit_status === 'add') {
              totalAdd = totalAdd + Number(this.apiResults[i].amount)
            } else {
              totalCashBack = totalCashBack + Number(this.apiResults[i].amount)
            }
          }

          this.totalAdd = Number(totalAdd).toFixed(2)
          this.totalCashBack = Number(totalCashBack).toFixed(2)
          generalTotal = Number(totalAdd) - Number(totalCashBack)
          this.generalTotal = generalTotal.toFixed(2)
        })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    getCustomerCreditID(credits) {
      this.customerCreditId = []
      for (let i = 0; i < credits.length; i++) {
        this.customerCreditId[i] = credits[i].credit_invoice_id
      }
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'credit_invoice_id'
      this.tableData.sortDir = 'asc'
      this.tableData.column = 'credit_invoice_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.filterTable(this.tableData.from_date, this.tableData.to_date)
      this.sortByColumn()
      this.getResults()
    },

    sendToExport() {
      let arr = ''

      for (let i = 0; i < this.customerCreditId.length; i++) {
        if (i < this.customerCreditId.length - 1) {
          arr = arr.concat('arr[]=' + this.customerCreditId[i] + '&')
        } else {
          arr = arr.concat('arr[]=' + this.customerCreditId[i])
        }
      }

      let hostName = window.location.hostname
      let protocol = window.location.protocol + '//'
      let fullHostName = protocol + hostName
      window.location.replace(fullHostName + '/api/customer-credit-export?' + arr)
    },

    openCreatCreditModal() {
      this.createCreditModal = true
    },

    openCashBackModal() {
      this.cashBackModal = true
    },

    openEditCreditModal(r) {
      this.the_credit_invoice_id = r.credit_invoice_id
      this.editData.amount = r.amount
      this.editData.note = r.note
      this.editData.user_id_fk = r.customer_id
      this.editCreditModal = true
    },

    closeCreatCreditModal() {
      this.createCreditModal = false
      this.checkAlert = false
      this.clear()
    },

    closeCashBackModal() {
      this.cashBackModal = false
      this.checkAlert = false
      this.cashBackError = false
      this.clearCashBack()
    },

    closeEditCreditModal() {
      this.editCreditModal = false
      this.checkAlert = false
      this.backendError = false
    },

    clear() {
      this.addData = {}
      this.$validator.reset()
    },

    clearCashBack() {
      this.cashBackData = {}
      this.cashBackModal = false
      this.checkAlert = false
      this.cashBackError = false
      this.$validator.reset()
    },

    cashBack() {
      this.load2 = true
      let token = localStorage.getItem('access_token')

      axios
        .put(this.cashBackUrl, this.cashBackData, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.cashBackError = false
          this.checkAlert = true
          this.getResults()
          this.clearCashBack()
          this.load2 = false
        })
        .catch(error => {
          if (error.response.data.message === 'cash back') {
            this.load2 = false
            this.checkAlert = false
            this.cashBackError = true
          } else {
            this.cashBackError = false
            this.checkAlert = true
            this.getResults()
            this.clearCashBack()
            this.load2 = false
          }
        })
    },

    createCredit() {
      this.load = true
      let token = localStorage.getItem('access_token')

      axios
        .post(this.baseUrl, this.addData, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.checkAlert = true
          this.getResults()
          this.clear()
          this.load = false
        })
        .catch(() => {
          this.checkAlert = true
          this.getResults()
          this.clear()
          this.load = false
        })
    },

    editCredit() {
      this.load2 = true
      let token = localStorage.getItem('access_token')

      axios
        .put(this.baseUrl + '/' + this.the_credit_invoice_id, this.editData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.backendError = false
          this.checkAlert = true
          this.getResults()
          this.load2 = false
        })
        .catch(error => {
          if (error.response.data.message === 'please') {
            this.checkAlert = false
            this.backendError = true
          } else {
            this.backendError = false
            this.checkAlert = true
            this.getResults()
            this.load2 = false
          }
        })
    },

    getCustomer() {
      let token = localStorage.getItem('access_token')

      axios
        .get(this.getCustomerUrl, {
          params: this.customerParam,
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.customersResult = response.data.data

          this.customersResult.forEach(c => {
            this.customers.push({
              text: c.full_name + ' - Tel: ' + c.phone_number,
              value: c.user_id
            })
          })
        })
    },

    deleteCredit(id) {
      swal({
        title: 'Are you sure?',
        text: 'Once deleted, you will not be able to return this credit!',
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .delete(this.baseUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
            .then(response => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(() => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
        }
      })
    },

    deleteCashBack(id) {
      swal({
        title: 'Are you sure?',
        text: 'Once deleted, you will not be able to return this cash back!',
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .delete(this.deleteCashBackUrl + '/' + id, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(response => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
        }
      })
    },

    openEditCashBackModal(data) {
      this.editCashBackModal = true
      this.editCashBackData = { ...data }
      this.the_credit_invoice_id = data.credit_invoice_id
    },

    closeEditCashBackModal() {
      this.editCashBackData = {}
      this.editCashBackModal = false
      this.checkAlert = false
      this.backendError = false
    },

    editCashBack() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.editCashBackUrl + '/' + this.the_credit_invoice_id, this.editCashBackData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.backendError = false
          this.checkAlert = true
          this.closeEditCashBackModal()
          this.getResults()
        })
        .catch(() => {
          this.checkAlert = false
          this.backendError = true
        })
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      this.getResults()
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      this.getCompanyData(token)
      axios
        .get(this.invoiceUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.detailResults = data.data

          this.detailData.credit_log_action_date = this.detailResults.credit_log_action_date
          this.detailData.credit_log_action_id = this.detailResults.credit_log_action_id
          this.detailData.invoice_number = this.detailResults.invoice_number
          this.detailData.description = this.detailResults.description
          this.detailData.action = this.detailResults.action
          this.detailData.created_at = this.detailResults.created_at
          this.detailData.amount = this.detailResults.amount
          this.detailData.customer_name = this.detailResults.customer_name
          this.detailData.customer_email = this.detailResults.customer_email
          this.detailData.phone_number = this.detailResults.customer_phone_number
          this.detailData.customer_address = this.detailResults.customer_address
          this.detailData.note = this.detailResults.note
          this.detailData.old_price = this.detailResults.old_price
        })
      this.modal(modal)
    },

    getCompanyData(token) {
      axios
        .get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.companyData = response.data.data
        })
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading {
  color: #006b8d;
  border-bottom: 2px solid #006b8d !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/user/user_credit/credit.vue